import {Environment} from 'ngx-paf-common';
import { AuthConfig } from 'angular-oauth2-oidc';


export const claimTypes = {
  email:"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
  name:"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name",
  identifier:"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
}

export const authConfig:AuthConfig = {
  // URL du service d'authentification Extranet
  // issuer:"https://localhost:5001",
  issuer:"https://auth.paf.heiv.info",
  //logoutUrl: window.location.origin + '/' + window.location.pathname.split('/')[1] +  +'/loggedout',
  postLogoutRedirectUri: window.location.origin, // + '/' + window.location.pathname.split('/')[1],
  //postLogoutRedirectUri:"http://localhost:4200",
  // Redirection vers l'appli en débug port local
  redirectUri: window.location.origin + '/' + window.location.pathname.split('/')[1] + '/login/callback', 
  //redirectUri: 'http://localhost:4200/login/callback',
  // The SPA's id. The SPA is registerd with this id at the auth-server
  // clientId: 'server.code',
  clientId: 'portail-fournisseurs-extranet',
  // Just needed if your auth server demands a secret. In general, this
  // is a sign that the auth server is not configured with SPAs in mind
  // and it might not enforce further best practices vital for security
  // such applications.
  // dummyClientSecret: 'secret',
  responseType: 'code',
  // set the scope for the permissions the client should request
  // The first four are defined by OIDC.
  // Important: Request offline_access to get a refresh token
  // The api scope is a usecase specific one
  scope: 'openid profile extranet',
  showDebugInformation: true
}



export const pafEnvironment : Environment = {
  debug:  true,
  apiBaseUrl:  'https://api.paf.heiv.info/api/',
  portalType:  'EXTRANET',
  oktaBaseUri:  'https://dev-53284405.okta.com/',
  production:  false,
  authenticationType:  'extranet',
  logo:  'LOGO_ALTRAD_ENDEL.png',
  logoUrl:   'https://www.altradendel.com/',
  logoNgStyle :  {'height':'55px','object-fit':'contains'}
}

